import React, { Component } from 'react';
import $ from "jquery";
import bulmaCalendar from 'bulma-calendar/dist/js/bulma-calendar.min';
import {parse, addMonths, format, eachDayOfInterval } from 'date-fns'

class StepThree extends Component {

    componentDidMount() {
        this.height();
        this.initCalender()
        $(window).off();
        $(window).on("resize", this.resize.bind(this));
    }

    componentDidUpdate() {
        this.height();
        this.initCalender();
    }

    initCalender = () => {
        if (this.props.dates) {
            let startDate = new Date();
            let endDate = addMonths(startDate, 3);
            
            let days = eachDayOfInterval({
                start: startDate,
                end: endDate,
            }).map((date) => {
                return format(date, "yyyyMMdd");
            });

            let diff = $(days).not(this.props.dates).get();
            let disabledDates = [];
            diff.forEach((date) => {
                disabledDates.push(parse(date, "yyyyMMdd", new Date()));
            });

            let selectedDate;
            if (this.props.data.date) {
                selectedDate = parse(this.props.data.date, "yyyyMMdd", new Date());
            } else {
                selectedDate = null;
            }
            
            const calendars = bulmaCalendar.attach('[type="date"]', {
                startDate: selectedDate,
                type: "date",
                color: "danger",
                lang: "nl",
                dateFormat: "YYYYMMDD",
                minDate: this.props.dates[0],
                maxDate: this.props.dates[this.props.dates.length - 1],
                disabledDates: disabledDates,   
                displayMode: "inline",
                showHeader: false,
                showTodayButton: false,
                showClearButton: false,
            });

            calendars.forEach(calendar => {
                calendar.datePicker.on('select', datepicker => {
                    this.props.setDate(datepicker.data.value());
                });
            });
        }
    }

    height() {    
        let totalHeight = $(window).outerHeight();
        totalHeight = (totalHeight > 900) ? 900 : totalHeight;
        let heightHeader = $(".header").outerHeight();
        let heightSteps = $(".steps").outerHeight();
        let heightPagination = $(".pagination-btns").outerHeight();

        let occupied = 
          heightHeader //header
        + heightSteps //steps
        + heightPagination //pagination
        - 5;
        
        let available = totalHeight - occupied + "px";
        document.querySelector(".stepTwo").style.height = available;
    }

    resize() {
        this.height();
    }

    renderContent = () => {
        if (this.props.dates && (this.props.dates.length === 0)) {
            this.openModal("no-dates");
        } else {
            return this.props.dates ? <input type="date" id="date-picker"/> : <div className="loader"></div>;
        }
    }

    openModal = (name) => {
        $("." + name).addClass("is-active");
    }

    closeModal = (name) => {
            $("." + name).removeClass("is-active");
    }

    maxModal = () => {
    let cHeight = $(".container").height();
        return  (cHeight - 154) + "px";
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="columns" style={{width: "100%"}}>
                    <div className="column" >
                        <div className="stepTwo">
                            {this.renderContent()}
                        </div>
                    </div>
                </div>
                <div className="modal no-dates">
                    <div className="modal-background"></div>
                    <div className="modal-content">
                        <div className="cModal" style={{maxHeight: this.maxHeightModalContent}}>
                            <div className="cModal-header">
                                Melding
                            </div>
                            <div className="cModal-content stylists-content" style={{maxHeight: this.maxModal()}}>
                            <p>
                                Er zijn geen datums beschikbaar in de komende drie maanden voor de gekozen behandeling(en)
                            </p>
                            </div>
                            <div className="cModal-footer">
                                <button className="button is-danger is-pulled-right" onClick={(e) => this.closeModal("no-dates")}>Sluiten</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default StepThree;